(function () {
  'use strict';
  function initialize(root) {
    if (root.dataset.jhpReady) return;
    root.dataset.jhpReady = 'true';
    var data = JSON.parse(root.querySelector('[data-jhp-data]').textContent);
    var form = root.querySelector('[data-jhp-form]');
    var qty = form.querySelector('[name="quantity"]');
    var submit = form.querySelector('[data-add-to-cart]');
    var status = root.querySelector('[data-jhp-status]');
    var sticky = root.querySelector('[data-jhp-sticky]');
    var stickyButton = sticky.querySelector('button');
    // Offset only by a real, currently visible Shopify sticky header.
    // Standalone previews have no sticky header and must sit flush at top:0.
    var navFrame = 0;
    function positionDetailNav() {
      navFrame = 0;
      var header = document.querySelector('.section-header.shopify-section-header-sticky');
      var bottom = header ? header.getBoundingClientRect().bottom : 0;
      var offset = Math.max(0, Math.min(window.innerHeight, bottom));
      root.style.setProperty('--jhp-nav-offset', offset + 'px');
    }
    function queueDetailNav() {
      if (!navFrame) navFrame = window.requestAnimationFrame(positionDetailNav);
    }
    positionDetailNav();
    window.addEventListener('scroll', queueDetailNav, {passive:true});
    window.addEventListener('resize', queueDetailNav, {passive:true});
    var selected = data.variants.find(function (v) { return String(v.id) === String(data.selected); }) || data.variants[0];
    var pending = false;
    var currency = data.currency || 'USD';
    var formatter = new Intl.NumberFormat(data.locale || 'en-US', { style:'currency', currency:currency });
    function money(cents) { return formatter.format(cents / 100); }
    function setText(selector, value) { root.querySelectorAll(selector).forEach(function (el) { el.textContent = value; }); }
    function show(selector, visible) { root.querySelectorAll(selector).forEach(function (el) { el.hidden = !visible; }); }
    function image(url, alt) {
      var main = root.querySelector('[data-jhp-image]');
      if (!url) return;
      main.src = url;
      main.alt = alt || data.title;
      main.removeAttribute('srcset');
    }
    function refreshFinancing(amount) {
      root.querySelectorAll('.affirm-as-low-as').forEach(function (el) { el.dataset.amount = String(amount); });
      if (window.affirm && window.affirm.ui && window.affirm.ui.refresh) window.affirm.ui.refresh();
      // Existing theme Klarna integration observes the Affirm amount and adds its row below.
      root.querySelectorAll('klarna-placement').forEach(function (el) { el.setAttribute('data-purchase-amount', String(amount)); });
    }
    function updateVariant(v, replaceUrl) {
      if (!v) return;
      selected = v;
      var extraDiscount = Number(v.extra_discount == null ? data.extraDiscount : v.extra_discount);
      if (!Number.isFinite(extraDiscount)) extraDiscount = 0;
      var finalPrice = v.price - Math.round(v.price * extraDiscount / 100);
      setText('[data-jhp-extra-percent]', String(extraDiscount));
      var compare = v.compare_at_price || 0;
      var discounted = compare > v.price;
      root.querySelectorAll('[data-jhp-variant]').forEach(function (card) {
        var active = String(card.dataset.jhpVariant) === String(v.id);
        card.classList.toggle('is-selected', active);
        card.querySelector('input').checked = active;
      });
      setText('[data-jhp-price]', money(v.price));
      setText('[data-jhp-compare]', money(compare));
      setText('[data-jhp-save]', money(Math.max(0, compare - v.price)) + ' OFF');
      setText('[data-jhp-final]', money(finalPrice));
      setText('[data-jhp-extra-save]', money(v.price - finalPrice));
      setText('[data-jhp-name]', v.title === 'Default Title' ? data.title : v.title);
      show('[data-jhp-compare], [data-jhp-save]', discounted);
      setText('[data-jhp-breakdown-original]', money(discounted ? compare : v.price));
      setText('[data-jhp-breakdown-total-save]', money(Math.max(0, compare - finalPrice)));
      var rule = v.quantity_rule || {min:1, increment:1};
      qty.min = String(rule.min || 1);
      qty.step = String(rule.increment || 1);
      if (rule.max) qty.max = String(rule.max); else qty.removeAttribute('max');
      qty.value = String(rule.min || 1);
      submit.disabled = !v.available;
      stickyButton.disabled = !v.available;
      submit.textContent = v.available ? 'Add to cart' : 'Sold out';
      stickyButton.textContent = v.available ? 'Add To Cart' : 'Sold out';
      image(v.image, v.title);
      status.textContent = '';
      refreshFinancing(finalPrice);
      if (replaceUrl && !data.preview) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', url);
      }
      updateBox(v);
      root.dispatchEvent(new CustomEvent('variant:change', { bubbles:true, detail:{ variant:v } }));
    }
    function updateBox(v) {
      var containers = root.querySelectorAll('[data-jhp-box]');
      var title = String(v.title).toLowerCase();
      var key = 'basic';
      if (title.indexOf('double') !== -1) key = 'double';
      else if (title.indexOf('200') !== -1) key = 'solar200';
      else if ((title.indexOf('7.2') !== -1 || title.indexOf('battery') !== -1) && title.indexOf('500') !== -1) key = 'batterySolar';
      else if (title.indexOf('battery') !== -1 || title.indexOf('7.2') !== -1) key = 'battery';
      else if (title.indexOf('500') !== -1) key = 'solar500';
      containers.forEach(function (container) { container.hidden = container.dataset.jhpBox !== key; });
    }
    root.querySelectorAll('[data-jhp-thumb]').forEach(function (button) {
      button.addEventListener('click', function () {
        image(button.dataset.jhpThumb, button.querySelector('img').alt);
        root.querySelectorAll('[data-jhp-thumb]').forEach(function (b) { b.setAttribute('aria-pressed', String(b === button)); });
      });
    });
    root.querySelectorAll('[data-jhp-variant] input').forEach(function (radio) {
      radio.addEventListener('change', function () {
        updateVariant(data.variants.find(function (v) { return String(v.id) === radio.value; }), true);
      });
    });
    root.querySelectorAll('[data-jhp-qty-step]').forEach(function (button) {
      button.addEventListener('click', function () {
        var step = Number(qty.step) || 1;
        var min = Number(qty.min) || 1;
        var max = qty.max ? Number(qty.max) : Infinity;
        qty.value = Math.min(max, Math.max(min, (Number(qty.value) || min) + Number(button.dataset.jhpQtyStep) * step));
        qty.dispatchEvent(new Event('change', { bubbles:true }));
      });
    });
    // One ID and one quantity are submitted to THIS store's cart endpoint.
    form.addEventListener('submit', async function (event) {
      event.preventDefault();
      if (pending || !selected.available || !form.reportValidity()) return;
      if (data.preview) {
        status.textContent = 'Preview only — the live page uses your Shopify product, price and inventory.';
        return;
      }
      pending = true;
      submit.disabled = stickyButton.disabled = true;
      submit.textContent = 'Adding…';
      status.textContent = '';
      try {
        var response = await fetch(data.cartAddUrl, {
          method:'POST', headers:{'Content-Type':'application/json', 'Accept':'application/json'},
          body:JSON.stringify({items:[{id:selected.id, quantity:Number(qty.value)}]})
        });
        var result = await response.json();
        if (!response.ok) throw new Error(result.description || result.message || 'Unable to add this item. Please try again.');
        status.appendChild(document.createTextNode('Added to your cart. '));
        var link = document.createElement('a'); link.href = data.cartUrl; link.textContent = 'View cart →'; status.appendChild(link);
        // Use the real cart page for the established gift/security/discount flow.
        window.location.assign(data.cartUrl);
      } catch (error) {
        status.textContent = error.message || 'Unable to add this item. Please try again.';
      } finally {
        pending = false;
        submit.disabled = stickyButton.disabled = !selected.available;
        submit.textContent = selected.available ? 'Add to cart' : 'Sold out';
      }
    });
    stickyButton.addEventListener('click', function () { form.requestSubmit(submit); });
    root.querySelectorAll('[data-jhp-tab-group]').forEach(function (group) {
      var tabs = Array.from(group.querySelectorAll('[role="tab"]'));
      var panels = group.querySelectorAll('[role="tabpanel"]');
      function activate(tab) {
        tabs.forEach(function (t) { var active = t === tab; t.setAttribute('aria-selected', String(active)); t.tabIndex = active ? 0 : -1; });
        panels.forEach(function (p) { p.hidden = p.id !== tab.getAttribute('aria-controls'); });
      }
      tabs.forEach(function (tab, index) {
        tab.addEventListener('click', function () { activate(tab); });
        tab.addEventListener('keydown', function (event) {
          var next;
          if (event.key === 'ArrowRight') next = tabs[(index + 1) % tabs.length];
          if (event.key === 'ArrowLeft') next = tabs[(index - 1 + tabs.length) % tabs.length];
          if (event.key === 'Home') next = tabs[0];
          if (event.key === 'End') next = tabs[tabs.length - 1];
          if (next) { event.preventDefault(); activate(next); next.focus(); }
        });
      });
      group.classList.add('is-enhanced');
      if (tabs[0]) activate(tabs[0]);
    });
    var runtime = root.querySelector('[data-jhp-runtime]');
    function updateRuntime() {
      var watts = Number(runtime.querySelector('input').value);
      var capacity = Number(runtime.querySelector('select').value);
      var output = runtime.querySelector('output');
      if (!Number.isFinite(watts) || watts <= 0 || watts > 3600) {
        output.textContent = 'Enter a load from 1–3,600 W'; return;
      }
      var hours = capacity * .85 / watts;
      output.textContent = 'About ' + (hours < 1 ? Math.round(hours * 60) + ' minutes' : hours.toFixed(1) + ' hours');
    }
    runtime.addEventListener('input', updateRuntime); runtime.addEventListener('change', updateRuntime); updateRuntime();
    root.querySelectorAll('[data-jhp-config]').forEach(function (button) {
      button.addEventListener('click', function () {
        var match = data.variants.find(function (v) {
          var t = v.title.toLowerCase();
          if (button.dataset.jhpConfig === 'battery') return t.includes('battery') && !t.includes('500');
          if (button.dataset.jhpConfig === 'solar') return t.includes('500') && !t.includes('7.2') && !t.includes('battery');
          return !t.includes('+') && !t.includes('double') && !t.includes('7.2') && !t.includes('battery');
        });
        if (match) updateVariant(match, true);
        form.scrollIntoView({behavior:window.matchMedia('(prefers-reduced-motion:reduce)').matches ? 'auto' : 'smooth', block:'start'});
      });
    });
    var dialog = root.querySelector('[data-jhp-dialog]');
    root.querySelector('[data-jhp-zoom]').addEventListener('click', function () {
      var main = root.querySelector('[data-jhp-image]'); dialog.querySelector('img').src = main.src;
      dialog.querySelector('img').alt = main.alt; dialog.showModal();
    });
    dialog.querySelector('button').addEventListener('click', function () { dialog.close(); });
    dialog.addEventListener('click', function (e) { if (e.target === dialog) dialog.close(); });
    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(function (entries) {
        sticky.classList.toggle('is-visible', !entries[0].isIntersecting && entries[0].boundingClientRect.top < 0);
        sticky.inert = !sticky.classList.contains('is-visible');
      }, {threshold:0});
      observer.observe(submit);
    }
    // Pause offscreen video, respect reduced motion and load only the active breakpoint.
    var reduced = window.matchMedia('(prefers-reduced-motion:reduce)').matches;
    var mobile = window.matchMedia('(max-width:749px)');
    root.querySelectorAll('video[data-jhp-video]').forEach(function (video) {
      var active = video.classList.contains('jhp-kv__mobile') === mobile.matches;
      if (!active) return;
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (entries) {
          if (entries[0].isIntersecting) {
            var source = video.querySelector('source');
            if (source && !source.src) { source.src = source.dataset.src; video.load(); }
            if (!reduced) video.play().catch(function () {});
          } else video.pause();
        }, {rootMargin:'150px'}).observe(video);
      }
    });
    updateVariant(selected, false);
  }
  function boot(scope) { scope.querySelectorAll('[data-jhp-root]').forEach(initialize); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { boot(document); }); else boot(document);
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();
